import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-clock2-icon lucide-clock-2",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12 6v6l4-2" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10
	})]
});
export default SvgClock;
